import {urlSafeDecode} from "@aws-amplify/core"
import {DefaultSocialProvider, FederatedSignInCustomState} from "./schemas"
import {Auth} from "aws-amplify"
import {ProviderIdentityMap} from "services/constants"
import { setFederatedSignInState } from "./cache"

/**
 * @typedef {{
 *  provider: import("services/auth/types").TAvailableSocialProvider
 *  customState: import("services/auth/types").FederatedSignInCustomState
 * }} FederatedSignInParams
 */

/**
 *
 * @param {FederatedSignInParams} params
 */
export function federatedSignIn({provider, customState}) {
  const isDefault = DefaultSocialProvider.safeParse(provider).success
  const identity = ProviderIdentityMap[provider]

  setFederatedSignInState(customState)

  if (isDefault) {
    return Auth.federatedSignIn({
      // @ts-ignore
      provider: identity,
    })
  } else {
    return Auth.federatedSignIn({
      customProvider: identity
    })
  }
}

/**
 * Extract and decode the last part of a dash-separated OAuth state string.
 *
 * Example: if state = "abcdef-ghi", decode "ghi"
 *
 * @param {string} oauthState
 * @returns {import("services/auth/types").FederatedSignInCustomState|null} customState or null if invalid
 */
export function decodeCustomState(oauthState) {
  if (typeof oauthState !== "string") return null

  const parts = oauthState.split("-")

  if (parts.length !== 2) return null

  const encoded = parts[parts.length - 1]
  return FederatedSignInCustomState.parse(JSON.parse(urlSafeDecode(encoded)))
}
